import React from 'react';
import classNames from 'classnames';

import moment from 'moment';
import Moment from 'react-moment';

import Avatar from '@material-ui/core/Avatar';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

import grey from '@material-ui/core/colors/grey';

const styles = theme => ({
  root:{
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.unit,
    maxWidth: '850px',
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: grey[100],
    }
  },
  avatar: {
    margin: '10px',
  },
  content: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  description: {
    flexGrow: 1,
  },
  divider: {
    height: '30px',
    maxWidth: '2px',
    minWidth: '2px',
    margin: '0px 0px',
    background: grey[300],
  },
  repeating: {
    width: '80px',
    marginLeft: theme.spacing.unit*2,
  },
  schedule: {
    width: '150px',
    marginLeft: theme.spacing.unit*2,
  },
  title: {
    width: '120px',
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*3,
  },
  reminder: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
});


const noteStatus = (note) => {
  switch (note.frequency) {
    case undefined:
      return <Moment format="MMM Do, YYYY">{note.reminderDate}</Moment>;
    case "daily":
      return "Daily";
    case "weekly":
      return "Weekly on " + moment(note.reminderDate).format("dddd");
    case "monthly":
      return "Monthly on the " + moment(note.reminderDate).format("Do");
    case "yearly":
      return "Yearly on " + moment(note.reminderDate).format("MMM Do");
    default:
      return "";
  }
}

const JobNoteCard = ({classes, note, handleEdit}) => {
  return(
    <Card
      className={classes.root}
      onClick={() => handleEdit(note)}
    >
      <div className={classes.content}>
        <Avatar className={classes.avatar}>
          N
        </Avatar>
        <div className={classes.title}>
          {note.title &&
            <Typography variant="subheading">
              {note.title}
            </Typography>
          }
          {note.reminderDate &&
            <Typography variant="caption">
              <Moment format="MMM Do, YYYY">{note.reminderDate}</Moment>
            </Typography>
          }
        </div>
        <Typography className={classes.description}>
          {note.description}
        </Typography>
        {!!note.isReminder &&
          <div className={classes.reminder}>
            <div className={classes.divider}></div>
            <div className={classes.schedule}>
              <Typography variant="subheading">
                {noteStatus(note)}
              </Typography>
              <Typography variant="caption">
                <Moment format="hh:mm A">{note.reminderDate}</Moment>
              </Typography>
            </div>
            <Typography className={classes.repeating}>
              {note.isRecurring ? "Repeating" : ""}
            </Typography>
          </div>
        }

      </div>
    </Card>

  );
};

export default withStyles(styles)(JobNoteCard);



// WEBPACK FOOTER //
// ./src/components/admin/Jobs/Notes/JobNoteCard.jsx